/**
 * @generated SignedSource<<2977a7122f7534d5818cf51667236ef2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type QuoteRuleInput = {
  allowAddToCart?: boolean | null;
  formControlsData?: string | null;
  isValidForAllProducts?: boolean | null;
  name?: string | null;
  notifyEmailList?: string | null;
  products?: ReadonlyArray<number> | null;
  quoteRuleID: number;
};
export type quoteRuleEditor_UpdateQuoteRuleMutation$variables = {
  input: QuoteRuleInput;
};
export type quoteRuleEditor_UpdateQuoteRuleMutation$data = {
  readonly quoteRuleUpdate: {
    readonly allowAddToCart: boolean;
    readonly id: string;
    readonly name: string | null;
    readonly notifyEmailList: string | null;
    readonly quoteRuleID: number;
  };
};
export type quoteRuleEditor_UpdateQuoteRuleMutation = {
  response: quoteRuleEditor_UpdateQuoteRuleMutation$data;
  variables: quoteRuleEditor_UpdateQuoteRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "QuoteRule",
    "kind": "LinkedField",
    "name": "quoteRuleUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quoteRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowAddToCart",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "notifyEmailList",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "quoteRuleEditor_UpdateQuoteRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "quoteRuleEditor_UpdateQuoteRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9fa26a388a8e11667b780781cfe008be",
    "id": null,
    "metadata": {},
    "name": "quoteRuleEditor_UpdateQuoteRuleMutation",
    "operationKind": "mutation",
    "text": "mutation quoteRuleEditor_UpdateQuoteRuleMutation(\n  $input: QuoteRuleInput!\n) {\n  quoteRuleUpdate(input: $input) {\n    id\n    quoteRuleID\n    name\n    allowAddToCart\n    notifyEmailList\n  }\n}\n"
  }
};
})();

(node as any).hash = "2309498282121983f91897bb697e08a7";

export default node;
